<template>
	<div class="editor-container width-100 display-flex flex-column flex-justify-space-between flex-align-center">
		<div class="editor-content-container width-100 display-flex flex-row height-100">
			<div class="flex-align-center display-flex flex-column flex-3">
				<ConfigurationEditHeader @add-new-block="addNewBlock" v-on="$listeners" class="mb-9" />
				<SetupMenu ref="setup_menu" @general-configuration-mode-changed="(v) => (isGeneralConfiguration = v)" editMode />
			</div>
			<div class="right-side-container display-flex flex-column flex-2">
				<WidgetSideBarSettings
					:previousSteps="{}"
					sideBarFocus="form"
					isConfigurationEditMode
					:isGeneralConfiguration="isGeneralConfiguration"
				/>
			</div>
		</div>
		<div class="width-100 flex-centerize footer-container">
			<AnemicButton :disabled="isButtonDisabled" @click="$emit('switch-to-test-mode')" class="run-button">
				Run setup to edit data
			</AnemicButton>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import SetupMenu from '@/views/Flow/configurations/SetupMenu';
import WidgetSideBarSettings from '@/components/BlockEditorWidget/WidgetSideBarSettings';
import ConfigurationEditHeader from '@/components/BlockEditorWidget/ConfigurationEditHeader';
import { generalConfigurationId } from '@/store/modules/selectedWorkflow/modules/configurations/getters';
import { userSpecificConfigurationId } from '@/store/modules/selectedWorkflow/modules/configurations/getters';
export default {
	name: 'ConfigurationEditor',
	components: {
		SetupMenu,
		WidgetSideBarSettings,
		ConfigurationEditHeader,
	},
	computed: {
		...mapGetters([userSpecificConfigurationId.fullPath, generalConfigurationId.fullPath]),
		generalConfigurationId() {
			return this[generalConfigurationId.fullPath];
		},
		userSpecificConfigurationId() {
			return this[userSpecificConfigurationId.fullPath];
		},
		isButtonDisabled() {
			return !this.userSpecificConfigurationId && !this.generalConfigurationId;
		},
	},
	methods: {
		addNewBlock(configurationType) {
			this.$refs.setup_menu.addNewBlock(configurationType);
		},
	},
	data() {
		return {
			isGeneralConfiguration: false,
		};
	},
};
</script>

<style scoped lang="scss">
$footer-height: 68px;

.editor-container {
	height: 100%;
	padding-bottom: $footer-height;
	background: var(--configuration-background);
}

.run-button {
	color: var(--bg-color);
	font-size: 14px !important;

	height: 46px !important;
	width: 194px !important;
	padding: 0px !important;
	background: var(--primary-color) !important;
}

.footer-container {
	bottom: 0px;
	z-index: 9999;
	position: fixed;
	height: $footer-height;
	background: var(--bg-color);
	box-shadow: 0px 3px 6px var(--shadow-color);
}

.right-side-container {
	overflow-y: auto;
	overflow-x: hidden;
	background: var(--bg-color);
	border-left: 1px solid var(--secondary-border-color);
}
</style>
